// extracted by mini-css-extract-plugin
export default {"skills":"style_skills__Ddb2l"};